import React from 'react';

const ClientRow = ({ client }) => {
  return (
  <tr>
  <td className="style_cl_name">
    <div style={{marginTop: 10}}>{client.name}</div>
    <div className="text-right" style={{float: 'right'}}>
      <a href={`/clientEdit/${client.id}`} className="btn btn-default ">
        <span className="glyphicon glyphicon-pencil" aria-hidden="true"></span>
      </a>
    </div>
  </td>
  <td className="style_cl_name">{client.project_count}</td>
  <td className="style_cl_name">
    {client.total_order_price != null && client.total_order_price !== 0 ? `₹ ${client.total_order_price}` : null}
  </td>
  </tr>
  );
};

export default ClientRow;
